// extracted by mini-css-extract-plugin
export default {"tableRow":"PalletPickUpTableItem_tableRow__RFNlz","tableCell":"PalletPickUpTableItem_tableCell__3ZqWR"};